import { apiFetch } from "./http";

export interface UserSession {
  authenticated: boolean;
  user?: {
    id: string;
    name?: string;
    email?: string;
    phone?: string;
    role?: string;
    // add any fields you rely on in legacyMain: isAdmin, isVerified, etc.
    [key: string]: any;
  };
}

export async function fetchSessionClient(): Promise<UserSession> {
  return apiFetch<UserSession>("/api/user-session", {
    method: "GET",
    cache: "no-store",
  });
}